import { useState, useEffect } from "react";
import { supabase } from "./supabase";

const css = `
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Lato:wght@300;400;700&display=swap');
*{box-sizing:border-box;margin:0;padding:0;}
body{background:#201E1A;color:#F0EAE0;font-family:'Lato',sans-serif;min-height:100vh;display:flex;align-items:center;justify-content:center;padding:20px;}
.wrap{max-width:360px;width:100%;text-align:center;}
.logo{font-family:'Bebas Neue',sans-serif;font-size:26px;letter-spacing:0.08em;margin-bottom:4px;}
.logo span{color:#C8A96E;}
.sub{font-size:9px;letter-spacing:0.3em;color:#7A7060;text-transform:uppercase;margin-bottom:32px;}
.card{background:#2B2925;border:1px solid rgba(200,169,110,0.2);border-radius:6px;padding:24px;margin-bottom:16px;}
.card-title{font-family:'Bebas Neue',sans-serif;font-size:20px;letter-spacing:0.06em;margin-bottom:16px;}
.rdv-row{display:flex;justify-content:space-between;padding:8px 0;border-bottom:1px solid rgba(200,169,110,0.1);font-size:12px;}
.rdv-row:last-child{border-bottom:none;}
.rdv-label{color:#7A7060;}
.rdv-val{color:#F0EAE0;}
.rdv-val.gold{color:#C8A96E;font-family:'Bebas Neue',sans-serif;font-size:15px;}
.btn{width:100%;padding:14px;background:#C8A96E;border:none;border-radius:3px;color:#201E1A;font-family:'Bebas Neue',sans-serif;font-size:15px;letter-spacing:0.2em;cursor:pointer;margin-bottom:10px;}
.btn:hover{background:#E2C88A;}
.btn:disabled{opacity:0.4;cursor:not-allowed;}
.btn-ghost{width:100%;padding:12px;background:transparent;border:1px solid rgba(200,169,110,0.2);border-radius:3px;color:#7A7060;font-family:'Lato',sans-serif;font-size:10px;letter-spacing:0.15em;text-transform:uppercase;cursor:pointer;}
.btn-ghost:hover{border-color:#C8A96E;color:#C8A96E;}
.status-icon{font-size:48px;margin-bottom:16px;}
.status-title{font-family:'Bebas Neue',sans-serif;font-size:26px;letter-spacing:0.06em;margin-bottom:8px;}
.status-sub{font-size:12px;color:#7A7060;line-height:1.6;}
.warning{background:rgba(200,80,80,0.08);border:1px solid rgba(200,80,80,0.2);border-radius:3px;padding:12px;font-size:11px;color:#d08080;margin-bottom:16px;line-height:1.6;}
`;

export default function CancelPage() {
  const [rdv, setRdv] = useState(null);
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState("idle");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const id = params.get("id");
    if (!id) { setStatus("notfound"); setLoading(false); return; }
    loadRdv(id);
  }, []);

  async function loadRdv(id) {
    const { data, error } = await supabase.rpc("reservation_par_id", { p_id: String(id) });
    const rdv = Array.isArray(data) ? data[0] : data;
    setLoading(false);
    if (error || !rdv) { setStatus("notfound"); return; }
    if (rdv.statut === "annulé") { setStatus("already"); setRdv(rdv); return; }
    setRdv(rdv);
    setStatus("confirm");
  }

  // ✅ Appelle /api/cancel-rdv qui gère Supabase + SMS admin
  async function confirmCancel() {
    setLoading(true);
    try {
      const res = await fetch("https://mendescut-barbershop.com/api/cancel-rdv", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: rdv.id }),
      });
      const data = await res.json();
      if (!res.ok || !data.success) { setStatus("error"); }
      else { setStatus("cancelled"); }
    } catch (e) {
      console.error("Erreur annulation:", e);
      setStatus("error");
    }
    setLoading(false);
  }

  return (
    <>
      <style>{css}</style>
      <div className="wrap">
        <div className="logo">MENDES <span>✂</span> CUT</div>
        <div className="sub">Annulation de rendez-vous</div>

        {loading && (
          <div style={{ color: "#7A7060", fontSize: 13, letterSpacing: "0.1em" }}>
            Chargement...
          </div>
        )}

        {!loading && status === "confirm" && rdv && (
          <>
            <div className="card">
              <div className="card-title">Votre <span style={{color:"#C8A96E"}}>rendez-vous</span></div>
              <div className="rdv-row"><span className="rdv-label">Service</span><span className="rdv-val gold">{rdv.service}</span></div>
              <div className="rdv-row"><span className="rdv-label">Date</span><span className="rdv-val">{rdv.date}</span></div>
              <div className="rdv-row"><span className="rdv-label">Heure</span><span className="rdv-val">{rdv.heure}</span></div>
              <div className="rdv-row"><span className="rdv-label">Total</span><span className="rdv-val">{rdv.total} CHF</span></div>
            </div>
            <div className="warning">
              ⚠️ Toute annulation doit être effectuée au minimum <strong>24h à l'avance</strong>.
              En cas d'absence non signalée, 50% du montant sera facturé.
            </div>
            <button className="btn" onClick={confirmCancel} disabled={loading}>
              Confirmer l'annulation
            </button>
            <button className="btn-ghost" onClick={() => window.location.href = "/"}>
              ← Garder mon RDV
            </button>
          </>
        )}

        {!loading && status === "cancelled" && (
          <div className="card" style={{textAlign:"center"}}>
            <div className="status-icon">✓</div>
            <div className="status-title">RDV <span style={{color:"#C8A96E"}}>annulé</span></div>
            <div className="status-sub">Votre rendez-vous a bien été annulé.<br/>Pour réserver un nouveau créneau, rendez-vous sur l'app.</div>
            <div style={{marginTop:20}}>
              <button className="btn" onClick={() => window.location.href = "/"}>Nouveau rendez-vous</button>
            </div>
          </div>
        )}

        {!loading && status === "already" && (
          <div className="card" style={{textAlign:"center"}}>
            <div className="status-icon">ℹ️</div>
            <div className="status-title">Déjà <span style={{color:"#C8A96E"}}>annulé</span></div>
            <div className="status-sub">Ce rendez-vous a déjà été annulé.</div>
            <div style={{marginTop:20}}>
              <button className="btn" onClick={() => window.location.href = "/"}>Nouveau rendez-vous</button>
            </div>
          </div>
        )}

        {!loading && (status === "notfound" || status === "error") && (
          <div className="card" style={{textAlign:"center"}}>
            <div className="status-icon">✗</div>
            <div className="status-title">Lien <span style={{color:"#C8A96E"}}>invalide</span></div>
            <div className="status-sub">Ce lien d'annulation est invalide ou a expiré.<br/>Contactez-nous au 079 172 35 75.</div>
          </div>
        )}
      </div>
    </>
  );
}
